export const MODEL_TABS = [
	{ key: "id", name: "common:field.id", sortKey: "id" },
	{ key: "name", name: "common:field.name", sortKey: "name" },
	{ key: "prompt", name: "dsi.agents.prompt" },
	{ key: "llm", name: "dsi.agents.llm-model" },
];
export const AI_MODEL_TABS = [
	{ key: "name", name: "common:field.name", sortKey: "name" },
	{ key: "description", name: "common:field.description" },
	{ key: "provider", name: "dsi.agents.models.table.provider" },
	{ key: "deployment", name: "dsi.agents.models.table.deployment" },
	{ key: "model", name: "dsi.agents.models.table.model" },
	{ key: "inputCost", name: "dsi.agents.ai-models.input-cost.column" },
	{ key: "outputCost", name: "dsi.agents.ai-models.output-cost.column" },
	{ key: "status", name: "dsi.agents.models.table.status" },
];
export const HISTORY_TABS = [
	{ name: "common:field.name", sortKey: "name" },
	{ name: "dsi.agents.launch" },
	{ name: "dsi.agents.duration" },
	{ name: "dsi.agents.execution-history.cost" },
	{ name: "dsi.agents.execution-history.total-cost" },
	{ name: "dsi.agents.project-name" },
	{ name: "dsi.agents.placeholders" },
	{ name: "dsi.agents.status" },
	{ name: "dsi.agents.tokens" },
	{ name: "dsi.agents.instantiated-tools" },
	{ name: "dsi.agents.results" },
];
export const FEATURE_TABS = [
	{ name: "dsi.agents.features.table.title.feature", sortKey: "featureName" },
	{ name: "dsi.agents.features.table.title.feature-description" },
	{ name: "dsi.agents.features.table.title.feature-placeholders" },
	{ name: "dsi.agents.features.table.title.associated-agent" },
];
